/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, NavbarBrand } from "reactstrap";
import { Link } from "react-router-dom";

import './FooterBlack.css'
// core components

function FooterBlack() {
  return (
    <>
      <footer className="subscribe-line subscribe-line-black" data-background-color="black" role="contentinfo" aria-label="Pie de página">
        <Container style={{ width: '100% !important' }} >
          <nav className="copyright float-left" aria-label="Enlaces legales y de contacto">
            <a href="/TerminosCondiciones" aria-label="Ver términos y condiciones">
              <h6 className="item-footer-color textot" style={{ textAlign: 'left', cursor: "pointer" }}>Términos y condiciones</h6>
            </a>
            <a href="/PoliticasDatosPersonales" aria-label="Ver política de tratamiento de datos personales">
              <h6 className="item-footer-color textot" style={{ textAlign: 'left', cursor: "pointer" }}>Política de Tratamiento de Datos Personales</h6>
            </a>
            <a href="/PoliticasDerechosAutor" aria-label="Ver políticas de derechos de autor">
              <h6 className="item-footer-color textot" style={{ textAlign: 'left', cursor: "pointer" }}>Políticas de derechos de autor</h6>
            </a>
            <a href="/CertificadoAccesibilidad" aria-label="Ver certificado de accesibilidad">
              <h6 className="item-footer-color textot" style={{ textAlign: 'left', cursor: "pointer" }}>Certificado de Accesibilidad</h6>
            </a>
            <a href="/PoliticasPrivacidadWeb" aria-label="Ver políticas de privacidad web">
              <h6 className="item-footer-color textot" style={{ textAlign: 'left', cursor: "pointer" }}>Políticas de Privacidad web</h6>
            </a>
            <a href="/MapaSitio" aria-label="Ver mapa del sitio">
              <h6 className="item-footer-color textot" style={{ textAlign: 'left', cursor: "pointer" }}>Mapa del Sitio</h6>
            </a>
            <a href="/#contact-us" aria-label="Ver canales de atención al público">
              <h6 className="item-footer-color textot" style={{ textAlign: 'left', cursor: "pointer" }}>Canales de Atención al Público</h6>
            </a>
            <p className="item-footer-color textot" style={{ textAlign: 'left', margin: 0 }}>
              <span aria-label="Teléfono de contacto">Teléfono – Conmutador: </span>
              <a href="tel:+576015144451" style={{ color: 'inherit' }}>(601) 514 4451</a>
            </p>
          </nav>
          <div className="copyright position-logo" id="copyright" >
            <NavbarBrand to="/" tag={Link} id="navbar-brand">
              <img  src={require("assets/img/LOGO-NAV.png")} alt="Logo de la notaría 51 de Bogotá" width="110px"></img>
            </NavbarBrand>
          </div>
        </Container>
        <Container style={{ width: '100% !important' }} >
            <div className="div-sinfony">
            <p style={{ margin: 0, display: 'inline' }}>
              © {new Date().getFullYear()}, Designed by{'\u00A0'}
              <a
                href="https://www.sinfony.com.co/"
                target="_blank"
                rel="noopener noreferrer"
                className="item-footer-color"
                aria-label="Visitar sitio de SINFONY (se abre en nueva ventana)"
              >
                SINFONY Todos los derechos reservados.
              </a>
            </p>
          </div>
        </Container>
      </footer>
      {/* <div className="subscribe-line subscribe-line-black">
        <Container>
          <Row >
            <Col className="col-6">
              <p style={{ fontSize: "16px", fontWeight: 500, color: 'white' }}>
                Tel: +57 (7) 6421111{" "}
              </p>
            </Col>
            <Col className="col-6 text-right">

              <span
                className="copyright"
                style={{ fontSize: "16px", fontWeight: 500, color: 'white' }}
              >
                © {new Date().getFullYear()}, Todos los derechos reservados.
              </span>
            </Col>
            <Col className="col-12">
              <p style={{ fontSize: "16px", fontWeight: 500, color: 'white' }}>
                Correo Físico: Carrera 21 # 22-30/40 barrio Alarcón del municipio de Bucaramanga.
              </p>
            </Col>
            <Col className="col-12">
              <p style={{ fontSize: "16px", fontWeight: 500, color: 'white' }}>
                Correo Institucional: decimabucaramaga@supernotariado.gov.co
              </p>
            </Col>
            <Col className="col-12">
              <p style={{ fontSize: "16px", fontWeight: 500, color: 'white' }}>
                Correo Notarial: notariadecimabucaramanga@gmail.com
              </p>
            </Col>
          </Row>
        </Container>
      </div> */}
    </>
  );
}

export default FooterBlack;
